import React from "react";
import { Route, Routes } from "react-router-dom";
import { PLReportList } from "./containers";

export const PLReport = () => {
  return (
    <Routes>
      <Route path="/" element={<PLReportList />} />
    </Routes>
  );
};
